import { SuperAdminTenantsPage } from "../../operator/console/super-admin-tenants";

export default function ConsoleSuperAdminTenants() {
  return <SuperAdminTenantsPage />;
}
